import { DataSet } from 'libs/end-to-end/src/types/databases/data-sets/data-set';

export const isMergeHrisIntegrationDataSet = (dataSet: DataSet): boolean => {
  const config = dataSet.config;

  return (
    config.dataSetType === 'Integration' &&
    config.integration.integrationType === 'Merge' &&
    config.integration.category === 'hris'
  );
};
